// routes/_app.$usernameRaw.liked-manga.($subTab).tsx
import type { ClientLoaderFunctionArgs } from 'react-router'
import { userProfileHandle, userProfileLoader } from 'src/utils/router/route'
import { dynamic } from 'src/utils/ssr'

const getClientModule = () =>
  import('src/clientRoutes/_app.$usernameRaw.liked-manga.($subTab)')

export const handle = userProfileHandle

export function loader() {
  return null
}

export async function clientLoader(args: ClientLoaderFunctionArgs) {
  return userProfileLoader({
    ...args,
    params: { ...args.params, tab: 'liked-manga' },
  })
}
clientLoader.hydrate = true

export default dynamic(getClientModule, { ssr: false })
